var map = {
	"./addCustomer.png": "1790",
	"./bg1.png": "175e",
	"./bg2.png": "9ffa8",
	"./bg3.png": "b28e",
	"./bg4.png": "1e76",
	"./bg5.png": "3005",
	"./bottomBg.png": "cd37",
	"./box1.png": "63b8",
	"./box2.png": "c48d",
	"./box3.png": "d4b8",
	"./cn.png": "8c26",
	"./facebook.png": "a15e",
	"./googlemap.png": "d67a",
	"./hint.png": "cb0f",
	"./hint2.png": "8968",
	"./icon1.png": "44c1",
	"./icon2.png": "954b",
	"./icon3.png": "0e0d",
	"./icon4.png": "b0e4",
	"./infobel_bg.png": "ffb6",
	"./layer1.png": "e9af",
	"./layer2.png": "2318",
	"./linkedin.png": "9bd6",
	"./logo-business.png": "f8a5",
	"./logo-buyer.png": "96f3",
	"./logo-commercial.png": "2e4f",
	"./logo-customs.png": "6ea7",
	"./logo-exhibition.png": "fd26",
	"./logo-socialMedia.png": "f8c9",
	"./logo-tender.png": "90230",
	"./nav1_0.png": "7b6a",
	"./nav1_1.png": "f6bf",
	"./nav2_0.png": "4392",
	"./nav2_1.png": "dc35",
	"./nav3_0.png": "2b9a",
	"./nav3_1.png": "7a97",
	"./nav4_0.png": "f8e6",
	"./nav4_1.png": "26df",
	"./nav5_0.png": "9b0d",
	"./nav5_1.png": "a945",
	"./nav6_0.png": "465f",
	"./nav6_1.png": "3fbd",
	"./nav7_0.png": "11aa",
	"./nav7_1.png": "0a69",
	"./no1.png": "f5f0",
	"./no2.png": "1680",
	"./no3.png": "5f4f",
	"./no4.png": "97c2",
	"./po1.png": "a262",
	"./po2.png": "cfcc",
	"./po3.png": "4f2d",
	"./po4.png": "91e8",
	"./po5.png": "9e24",
	"./twitter.png": "e9aa",
	"./vip1.png": "9957",
	"./vip2.png": "32c1",
	"./yellowpages.png": "7cfa",
	"./yelp.png": "1e5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be90";